module.exports = __webpack_public_path__ + "img/flag-JP.5ac5e61b.png";